import script from "./SettingsProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsProfileView.vue?vue&type=script&setup=true&lang=js"

import "./SettingsProfileView.vue?vue&type=style&index=0&id=ee7321e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee7321e6"]])

export default __exports__